import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCalls } from '../context/calls-context.jsx';
import { isActiveAttempt } from '../model/calls.model.js';

export default function CallsPanel() {
  const { t } = useTranslation();
  const calls = useCalls();
  if (!calls.canView || (!calls.error && !calls.active.length)) return null;
  return <aside className="card shadow position-fixed bottom-0 end-0 m-3" style={{ zIndex: 1040, width: 'min(360px, calc(100vw - 2rem))', maxHeight: '45vh', overflowY: 'auto' }} aria-label={t('calls.currentCall')}>
    <div className="card-body p-3">
      <strong>{t('calls.currentCall')}</strong>
      {calls.error && <p role="alert" className="text-danger small mb-2">{t(calls.error)}</p>}
      {calls.active.map((item) => <div className="border-top mt-2 pt-2" key={item.id}>
        <Link to={`/profiles/${encodeURIComponent(item.profileId)}`}>{item.profileLabel}</Link>
        <div aria-live="polite" className="small my-1">{t(`calls.status.${item.technicalStatus}`)}</div>
        {item.technicalStatus === 'submission_unknown' && <p className="small text-warning">{t('calls.unknownHelp')}</p>}
        {item.technicalStatus === 'submission_unknown' && !item.resolvedAt && calls.canManage && <button className="btn btn-sm btn-outline-primary" onClick={() => calls.openEditor('outcome', item)}>{t('calls.checkSubmission')}</button>}
        {!isActiveAttempt(item) && <div className="d-flex gap-2">
          {calls.canManage && <button className="btn btn-sm btn-primary" onClick={() => calls.openEditor('outcome', item)}>{t('calls.fillOutcome')}</button>}
          <button className="btn btn-sm btn-outline-secondary" onClick={() => calls.dismiss(item.id)}>{t('calls.dismiss')}</button>
        </div>}
      </div>)}
    </div>
  </aside>;
}
